export default __webpack_public_path__ + "assets/webgl/buffer.688e8210.bin";